
import { call, select, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import certificates from '../Actions/certificates';
import  {getUserData }  from './user';
import { saveCertificatesRequest, deleteCertificateRequest } from '../Api/Certificates';
import { startLoading, stopLoading } from '../LoadingHelper';
import { CATEGORY_GA, eventGA } from  '../Helpers/GoogleAnalytics';
import taxpayer from '../Actions/taxpayer';
const { setCertificatesData } = certificates.actions;
const { getTaxpayerVolumeData } = taxpayer.actions;
const certificatesPagination = state => state.certificates.certificatesPagination;

export function* saveCertificates({data}) {
    const query = yield select(certificatesPagination);
    let { fileList, password} = data;
    if(fileList.length === 0){
        message.error(`Favor de cargar los certificados` , 5);
    }else if(!fileList[0]){
        message.error(`Favor de cargar su archivo .cer` , 5);
    }else if(!fileList[1]){
            message.error(`Favor de cargar su archivo .key` , 5);
    }else if(password === ''){
        message.error(`Favor de introducir la contraseña de los certificados` , 5);
    }else{
        const loadingId = yield call(startLoading,'loadingCertificates');
        const formData = new FormData();
        formData.append('password', password)
        formData.append('publicKey', fileList[0]);
        formData.append('privateKey', fileList[1]);
        const response = yield call(saveCertificatesRequest,formData);
        try {
            if(response && response.status === 'success') {
                eventGA(CATEGORY_GA.configuration.loadFiel);
                let data = {
                    fileList: [],
                    password: ''
                }
                message.success('Certificados guardados correctamente', 5);

                yield put(setCertificatesData(data));
                yield put(getTaxpayerVolumeData());
                yield call(getUserData,{query});
            }else{
                message.error(`Ha ocurrido un error ${response.message}` , 5);
            }
        }catch(error){
            message.error(`Ha ocurrido un error ${error.message}` , 5);
        }finally {		
            yield call(stopLoading, loadingId);
        }
    } 
}

export function* deleteCertificate({taxId, query}) {
    const loadingId = yield call(startLoading,'loadingCertificates');
    try {
        const response = yield call(deleteCertificateRequest,taxId);
        if(response.status === 'success'){
            eventGA(CATEGORY_GA.configuration.deleteFiel);
            yield call(getUserData, {query});
            message.success('El certificado se eliminó correctamente', 5);            
        }else 
            message.success(`Ha ocurrido un error ${response.message}`, 5);
    }catch(error) {
        message.error(`Ha ocurrido un error ${error.message}`, 5);
    }finally {		
        yield call(stopLoading, loadingId);
    }
}

export function* certificatesSaga() {    
    yield takeEvery(certificates.types.SAVE_CERTIFICATES, saveCertificates);
    yield takeEvery(certificates.types.DELETE_CERTIFICATE, deleteCertificate);
}
